import ErrorMessage from "components/ErrorMessage"
import { useState } from "react";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { InputWrapper } from "./styled"

const Input = ({ isError, type = "text", className, message, ...props }) => {
    const [typeInput, setType] = useState(type)
    return (
        <InputWrapper>
            {
                message &&
                <ErrorMessage >{message}</ErrorMessage>
            }
            <div>
                <input type={typeInput} className={`regular  text-black ${className} ${isError ? "b-red-1 bg-grey2" : "b-grey-1 bg-white"} ${type === "password" ? "input_password" : ""}`}  {...props} />
                {
                    type === "password" && typeInput !== "password" &&
                    <FaEye onClick={() => setType("password")} className="eye_icon clickable text-grey" />
                }
                {
                    type === "password" && typeInput === "password" &&
                    <FaEyeSlash onClick={() => setType("text")} className="eye_icon clickable text-grey" />
                }
            </div>
        </InputWrapper>
    )
}

export default Input